<template>
  <div
    @click="openDetail"
    class="dorm-card"
    :class="[
      {
        premium: isAdvert,
        male: type === 1,
        female: type === 2
      }
    ]"
  >
    <div class="dorm-card__top">
      <!--"dorm-card-badge" elementi sadece dorm 1. sıra sabit reklamı var ise görünür.-->
      <div class="dorm-card-badge" v-if="isAdvert">
        <div class="badge_in">
          <div class="img_wrp">
            <img
              src="@/assets/img/star-icon-white.svg"
              alt=""
              class="img-fluid"
            />
          </div>
          <span>Popüler</span>
        </div>
      </div>
      <img
        :src="image ? image : require('@/assets/img/yurtlarburada-default.jpg')"
        alt=""
        class="dorm-card__img"
      />
      <div class="dorm-card__overlay">
        <v-button class="dorm-card__button" title="İncele" />
      </div>
    </div>
    <div class="dorm-card__cnt">
      <div class="dorm-card__content">
        <div class="dorm-card__title">
          <small>{{ city }}, {{ district }}</small>
          <span class="dorm-card__title-main" :title="title">
            {{ title }}
          </span>
        </div>
        <div class="dorm-card-price">
          <div class="dorm-card-price__title">{{ dailyPrice }} TL</div>
          <div class="dorm-card-price__txt">
            ‘den başlayan<br />oda fiyatları
          </div>
        </div>
      </div>
      <div class="dorm-card__bottom">
        <div class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-bed" />
          </div>
          <div class="btn-txt">{{ capacity }} kişilik oda</div>
        </div>

        <div v-if="meal && !branchCount" class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-food" />
          </div>
          <div class="btn-txt">{{ meal }} Öğün</div>
        </div>
        <div
          v-else-if="!meal && !isWifi && !branchCount"
          class="dorm-card__inf"
        >
          <div class="icon-font">
            <svg-icon type="icon-food" />
          </div>
          <div class="btn-txt" disabled>
            Yok
          </div>
        </div>
        <div v-else-if="!meal && isWifi && !branchCount" class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-wifi" />
          </div>
          <div class="btn-txt">
            Wifi Var
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomSiteCard',
  props: {
    id: {
      default: null
    },
    dormId: {
      default: null
    },
    dormSlug: {
      default: null
    },
    type: {
      default: null
    },
    isAdvert: {
      default: null
    },
    city: String,
    district: String,
    title: String,
    image: String,
    capacity: {
      default: null
    },
    dailyPrice: {
      default: null
    },
    branchCount: {
      default: null
    },
    meal: {
      default: null
    },
    isWifi: {
      default: null
    }
  },
  methods: {
    openDetail() {
      let extension = this.$helpers.mobileCheck() ? '_self' : '_blank'
      window.open(
        `${window.location.origin}/${this.dormSlug}-o-${this.dormId}-${this.id}`,
        extension
      )
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/dorm-card';
.mywashed {
  background-blend-mode: lighten;
}
</style>
